import { useEffect } from 'react';

// Web Vitals monitoring for SEO performance
const WebVitals: React.FC = () => {
  useEffect(() => {
    const reportWebVitals = async () => {
      try {
        const webVitals = await import('web-vitals');
        const { getCLS, getFID, getFCP, getLCP, getTTFB } = webVitals;

        // Report to Google Analytics
        const sendToAnalytics = (metric: any) => {
          if (window.gtag) {
            window.gtag('event', metric.name, {
              event_category: 'Web Vitals',
              event_label: metric.id,
              value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
              non_interaction: true,
            });
          }
        };

        // Monitor Core Web Vitals
        getCLS(sendToAnalytics);
        getFID(sendToAnalytics);
        getFCP(sendToAnalytics);
        getLCP(sendToAnalytics);
        getTTFB(sendToAnalytics);

        // Add performance observer for additional metrics
        if ('PerformanceObserver' in window) {
          // Monitor largest contentful paint for main content
          const observer = new PerformanceObserver((list) => {
            const entries = list.getEntries();
            entries.forEach((entry) => {
              if (window.gtag && entry.entryType === 'largest-contentful-paint') {
                const lcpEntry = entry as any; // LCP entries have additional properties
                window.gtag('event', 'lcp_element', {
                  event_category: 'Performance',
                  event_label: lcpEntry.element?.tagName || 'unknown',
                  value: Math.round(entry.startTime)
                });
              }
            });
          });

          observer.observe({ entryTypes: ['largest-contentful-paint'] });
        }

        // Monitor page load performance
        window.addEventListener('load', () => {
          const navigation = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
          
          if (window.gtag && navigation) {
            const metrics = {
              dns_time: navigation.domainLookupEnd - navigation.domainLookupStart,
              connect_time: navigation.connectEnd - navigation.connectStart,
              response_time: navigation.responseEnd - navigation.responseStart,
              dom_load_time: navigation.domContentLoadedEventEnd - navigation.domContentLoadedEventStart,
              total_load_time: navigation.loadEventEnd - navigation.fetchStart // Use fetchStart instead of navigationStart
            };

            Object.entries(metrics).forEach(([key, value]) => {
              if (value > 0) {
                window.gtag('event', 'page_timing', {
                  event_category: 'Performance',
                  event_label: key,
                  value: Math.round(value)
                });
              }
            });
          }
        });

      } catch (error) {
        console.log('Web Vitals not available:', error);
      }
    };

    reportWebVitals();
  }, []);

  return null;
};

export default WebVitals;


